import React from 'react';
import { isEmpty } from 'lodash';

import TextField from '@material-ui/core/TextField';

import styles from './ACCategory.module.scss';

export default class ACDateTimeRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      text: props.text || props.label || '',
    };
    this.onClickContent = this.onClickContent.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.onBlurText = this.onBlurText.bind(this);
  }

  onClickContent() {
    this.setState({ isEditable: true });
  }

  onChangeText(e) {
    let { text } = this.state;

    text = e.target.value;

    this.setState({ text });
  }

  onBlurText() {
    this.setState({ isEditable: false });
    const { text } = this.state;
    const { label } = this.props;

    if (!(text.toUpperCase() === label.toUpperCase() || isEmpty(text))) {
      this.props.onUpdateTextFunc(label, text);
    }
  }

  renderLabelBasedCategory(label) {
    return (
      <div className={styles.container}>
        <hr className={styles.horizontalLine}></hr>
        <div className={styles.content} onClick={this.onClickContent}>
          {label}
        </div>
      </div>
    );
  }

  renderTextBasedCategory(text) {
    return (
      <div className={styles.container}>
        <hr className={styles.horizontalLine}></hr>
        <div className={styles.content}>
          <TextField
            id="standard-text"
            className={styles.standardText}
            value={text}
            onBlur={this.onBlurText}
            onChange={this.onChangeText}
            autoFocus
          />
        </div>
      </div>
    );
  }

  render() {
    const { label = '' } = this.props;
    const { isEditable, text } = this.state;

    if (!isEditable) return this.renderLabelBasedCategory(label);
    else return this.renderTextBasedCategory(text);
  }
}
